import { Button } from 'rsuite';
import { Notifications } from '../../pages/notifications/notifications';

export const NotificationsPopup = (props: { setHideNotification: (state: boolean) => void }) => {
  return (
    <div
      className="h-[100%] w-[100%] bg-[--rs-backdrop] fixed top-0 left-0 px-5 py-4"
      style={{ zIndex: 10000 }}>
      <div>
        <div className="text-[--rs-white] bg-[--rs-primary-500] text-md px-3 py-4">
          پیام های جدید
        </div>
        <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <Notifications />
        </div>
      </div>
      <div className="flex items-center pt-3 pb-3 bg-[--rs-white]">
        <Button
          appearance="primary"
          className="!text-[--rs-black] mx-auto !rounded-xl !py-3 !px-2"
          onClick={() => props.setHideNotification(true)}>
          باشه، برو به برنامه
        </Button>
      </div>
    </div>
  );
};
